import { render, staticRenderFns } from "./ImportTable.vue?vue&type=template&id=fa64ac1a&scoped=true"
import script from "./ImportTable.vue?vue&type=script&lang=js"
export * from "./ImportTable.vue?vue&type=script&lang=js"
import style0 from "./ImportTable.vue?vue&type=style&index=0&id=fa64ac1a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa64ac1a",
  null
  
)

export default component.exports